import Mock from 'mockjs'

Mock.setup({ time: '200-600' })
Mock.mock('/apimock/getGoodsList', {
    'ret': 0,
    'data': [
        {
            indexNum: 1,
            'uuid|33123212-54322134': 10,
            'phone|+1': 13609874673,
            avatar: '@image()',
            name: '@name',
            'isMembers|1': true,
            operate: {}
        },
        {
            indexNum: 2,
            'uuid|33123212-54322134': 20,
            'phone|+1': 13609874673,
            avatar: '@image',
            name: '@name',
            'isMembers|1': true,
            operate: {}
        },
        {
            indexNum: 3,
            'uuid|33123212-54322134': 11,
            'phone|+1': 13609874673,
            avatar: '@image',
            name: '@name',
            'isMembers|1': false,
            operate: {}
        },
        {
            indexNum: 4,
            'uuid|33123212-54322134': 12,
            'phone|+1': 13609874673,
            avatar: '@image',
            name: '@name',
            'isMembers|1': true,
            operate: {}
        },
        {
            indexNum: 5,
            'uuid|33123212-54322134': 13,
            'phone|+1': 13609874673,
            avatar: '@image',
            name: '@name',
            'isMembers|1': false,
            operate: {}
        },
        {
            indexNum: 6,
            'uuid|33123212-54322134': 14,
            'phone|+1': 13609874673,
            avatar: '@image',
            name: '@name',
            'isMembers|1': true,
            operate: {}
        },
        {
            indexNum: 7,
            'uuid|33123212-54322134': 21,
            'phone|+1': 13609874673,
            avatar: '@image',
            name: '@name',
            'isMembers|1': true,
            operate: {}
        },
        {
            indexNum: 8,
            'uuid|33123212-54322134': 34,
            'phone|+1': 13609874673,
            avatar: '@image',
            name: '@name',
            'isMembers|1': true,
            operate: {}
        },
        {
            indexNum: 9,
            'uuid|33123212-54322134': 54,
            'phone|+1': 13609874673,
            avatar: '@image',
            name: '@name',
            'isMembers|1': false,
            operate: {}
        },
        {
            indexNum: 10,
            'uuid|33123212-54322134': 65,
            'phone|+1': 13609874673,
            avatar: '@image',
            name: '@name',
            'isMembers|1': false,
            operate: {}
        }
    ]
})

Mock.mock('getAllMemberStore', {
    'ret': 0,
    'data': ['西乡店', '宝安店', '南山店', '罗湖店', '坪洲店', '宝安西乡二店']
})


// WEBPACK FOOTER //
// ./src/api/mockApi.js